import cx from "classnames";
import { getPlatforms, IonButton, IonLabel } from "@ionic/react";
import { includes } from "lodash";

import s from "./MobileRedirect.module.scss";
import appStoreLogo from "../../../assets/images/app-store-badge.png";
import playStoreLogo from "../../../assets/images/google-play-badge.png";
import MobileBgField from "../../../assets/images/v2RedirectDownload/mobile_bg_field.png";
import mobileAndroidPhoneImg from "../../../assets/images/v2RedirectDownload/mobile_android_phone.png";
import mobileIosPhoneImg from "../../../assets/images/v2RedirectDownload/mobile_ios_phone.png";

import { ProgressBar } from "../ProgressBar";

const MobileRedirect = ({ isOneOffEntry }: { isOneOffEntry?: boolean }) => {
  const platforms = getPlatforms();
  const showAndroid = includes(platforms, "android");
  const showIphone = includes(platforms, "ios");
  return (
    <div className={s.downloadAppContentSuccess}>
      <ProgressBar isOneOffEntry={isOneOffEntry} />
      <div className={s.content}>
        <div className={s.textImgContents}>
          <img className={s.mobileBgField} src={MobileBgField} alt="" loading="lazy" decoding="async" />
          <div className={s.textContent}>
            <div className={s.headerCntr}>
              <IonLabel className={cx(s.textHeader)}>WELCOME</IonLabel>
              <IonLabel className={cx(s.textHeader)}>BACK!</IonLabel>
            </div>
            <IonLabel className={s.textSubHeader}>
              By downloading our app you will unlock{" "}
              <span>FREE BONUS ENTRIES</span> + <span>Heaps more!</span>
            </IonLabel>
            {showAndroid && (
              <IonButton
                fill="clear"
                className={cx(s.dlBtns, "ion-no-padding ion-no-margin")}
                onClick={() => {
                  window.open(
                    "https://play.google.com/store/apps/details?id=com.winnerslocker.winnerslocker"
                  );
                }}
              >
                <img className={s.downloadButtonImage} src={playStoreLogo} alt="" loading="lazy" decoding="async" />
              </IonButton>
            )}
            {showIphone && (
              <IonButton
                fill="clear"
                className={cx(s.dlBtns, "ion-no-padding ion-no-margin")}
                onClick={() => {
                  window.open(
                    "https://apps.apple.com/us/app/winners-locker/id6454697542"
                  );
                }}
              >
                <img className={s.downloadButtonImage} src={appStoreLogo} alt="" loading="lazy" decoding="async" />
              </IonButton>
            )}
            <img
              src={showIphone ? mobileIosPhoneImg : mobileAndroidPhoneImg}
              className={s.phoneContent}
              alt=""
              loading="lazy"
              decoding="async"
            />
            <div className={cx(s.heapsCntr)}>
              <IonLabel className={cx(s.heapsText, s.header)}>
                The heaps more part:
              </IonLabel>
              <ul>
                {!isOneOffEntry && (
                  <li>
                    <IonLabel className={cx(s.heapsText)}>
                      Get bonus entries just for downloading the app
                    </IonLabel>
                  </li>
                )}
                <li>
                  <IonLabel className={cx(s.heapsText)}>
                    Track everything - entries, wins, upcoming draws & more
                  </IonLabel>
                </li>
                <li>
                  <IonLabel className={cx(s.heapsText)}>
                    Redeem Locker Points for rewards and savings
                  </IonLabel>
                </li>
                <li>
                  <IonLabel className={cx(s.heapsText)}>
                    Auto entries into all major prize draws
                  </IonLabel>
                </li>
                <li>
                  <IonLabel className={cx(s.heapsText)}>
                    Play games to score bonus entries, points, and cash
                  </IonLabel>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MobileRedirect;
